import { getWithToken, postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";
const product_template_sharing = apiUrl + "/product_template_sharing";
const routes = {
  label: "Product Template Sharing",
  root: product_template_sharing,
  get_by_company_id: product_template_sharing + "/get_by_company_id",
  new: product_template_sharing + "/new",
  delete: product_template_sharing + "/delete",
};
export const ProductTemplateSharing = {
  label: routes.label,
  get_by_company_id: (company_id) => getWithToken(routes.get_by_company_id, { company_id }),
  /**
   *
   * @param {[{company_id: number, product_id: string}]} product_template_sharings
   * @returns
   */
  new: (product_template_sharings) => postWithToken(routes.new, product_template_sharings),
  /**
   *
   * @param {[{company_id: number, product_id: string}]} product_template_sharings
   * @returns
   */
  delete: (product_template_sharings) => postWithToken(routes.delete, product_template_sharings),
};
